import React, {PureComponent} from 'react';
import cx from 'classnames';
import FilterContainer from './FilterContainer';
import SortContainer from './SortContainer';
import i18n from '../../utils/i18n';
import PropTypes from 'prop-types';

class SortingAndFiltering extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showFilter: false,
      showSort: false
    };
  }

  handleFilterDropdown(state) {
    this.setState({showFilter: state});
  }

  handleSortDropdown(state) {
    this.setState({showSort: state});
  }

  render() {
    const {showFilter, showSort} = this.state;
    const baseFilterToggleButtonClass = 'isui-filter-sort__show-filter';
    const filterToggleButtonClass = cx(baseFilterToggleButtonClass, {
      'isui-filter-sort__show-filter--open': this.state.showFilter
    });

    return (
      <div className="SortingAndFiltering">
        <div className="isui-filter-sort">
          <div className="isui-filter-wrapper">
            <span
              className={filterToggleButtonClass}
              onClick={() => {
                this.setState({showFilter: !this.state.showFilter, showSort: false});
              }}
            >
              {i18n.t('filter.filter')}
            </span>
          </div>
          <SortContainer
            disabled={false}
            onLabelClick={() => {
              this.setState({showSort: !showSort});
            }}
            displaySortDropdown={this.handleSortDropdown.bind(this)}
            isOpen={showSort}
          />
        </div>

        <FilterContainer
          visible={showFilter}
          displayFilterDropdown={this.handleFilterDropdown.bind(this)}
          outsideClickIgnoreClass={baseFilterToggleButtonClass}
          container={this.props.container}
        />
      </div>
    );
  }
}

SortingAndFiltering.propTypes = {
  container: PropTypes.object
};

SortingAndFiltering.displayName = 'SortingAndFiltering';

export default SortingAndFiltering;
